import ServiceBase from './ServiceBase';

export default class FileService extends ServiceBase {
    constructor($http) {
        super($http);
    }

    getFile(key) {
        return this.$http.get('file/getFile', { params: { key }, responseType: 'blob' });
    }
}